// Seed data: ad banners / featured placements.
// Placements: home_hero, home_mid, sponsors_page, forum_page

export const seedBanners = [
  {
    id: "seed-bn-1",
    title: "Sabha Day 2026 Souvenir",
    subtitle: "Honouring the supporters who stand with us — download the printed keepsake.",
    image_url:
      "https://images.unsplash.com/photo-1595658658481-d53d3f999875?auto=format&fit=crop&w=1600&q=70",
    link_url: "/sponsors",
    placement: "home_hero",
    is_active: true,
    is_featured: true,
    sort_order: 1,
  },
  {
    id: "seed-bn-5",
    title: "Membership — Find Your Record",
    subtitle: "Search 67,000+ life members across every parish unit in the Archdiocese.",
    image_url:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1600&q=70",
    link_url: "/membership",
    placement: "home_hero",
    is_active: true,
    is_featured: false,
    sort_order: 2,
  },
  {
    id: "seed-bn-2",
    title: "Join the BCS Civil Services Academy",
    subtitle: "Weekend batches for UPSC / MPSC aspirants. Admissions open for 2026–27.",
    image_url:
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1600&q=70",
    link_url: "/our-work/youth-training",
    placement: "home_mid",
    is_active: true,
    is_featured: false,
    sort_order: 1,
  },
  {
    id: "seed-bn-4",
    title: "Become a Sponsor",
    subtitle: "Support the Sabha's work across 48+ units. Feature your business in the Souvenir.",
    image_url:
      "https://images.unsplash.com/photo-1569758267239-d08deb78bb1a?auto=format&fit=crop&w=1600&q=70",
    link_url: "/contact",
    placement: "home_mid",
    is_active: true,
    is_featured: false,
    sort_order: 2,
  },
  {
    id: "seed-bn-3",
    title: "HDFC Bank — NRI Banking Services",
    subtitle: "Dedicated banking solutions for the Catholic community. Featured supporter.",
    image_url:
      "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=1600&q=70",
    link_url: "/sponsors",
    placement: "sponsors_page",
    is_active: true,
    is_featured: true,
    sort_order: 1,
  },
  {
    id: "seed-bn-6",
    title: "Sabha Day 2026 — Thank Our Sponsors",
    subtitle: "Browse businesses, parishes and families who make our mission possible.",
    image_url:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1600&q=70",
    link_url: "/sponsors",
    placement: "sponsors_page",
    is_active: true,
    is_featured: false,
    sort_order: 2,
  },
  {
    id: "seed-bn-7",
    title: "Voter Registration Drive 2026",
    subtitle: "The Socio Civic Forum is running awareness camps across parish units.",
    image_url:
      "https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?auto=format&fit=crop&w=1600&q=70",
    link_url: "/our-work/socio-civic-political",
    placement: "forum_page",
    is_active: true,
    is_featured: true,
    sort_order: 1,
  },
  {
    id: "seed-bn-8",
    title: "Environment Forum — Tree Plantation",
    subtitle: "Join our post-COVID drive to plant over one lakh trees across Mumbai.",
    image_url:
      "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=1600&q=70",
    link_url: "/our-work/environment",
    placement: "forum_page",
    is_active: true,
    is_featured: false,
    sort_order: 2,
  },
];
